module.exports = __webpack_public_path__ + "img/wasatch.21e78b72.png";